<script setup lang="ts">
    import { useToastStore } from '@/stores/toast';
    import { PhCheckCircle, PhWarningDiamond } from '@phosphor-icons/vue';

    const { toasts } = useToastStore();
</script>

<template>
    <div class="fixed bottom-14 left-1/2 -translate-x-1/2 z-9999 px-4 w-full">
        <TransitionGroup
            enter-active-class="transition-all ease-out duration-200"
            enter-from-class="transform translate-y-full opacity-0 scale-95"
            enter-to-class="transform translate-y-0 opacity-100 scale-100"
            leave-active-class="transition-all ease-in duration-150"
            leave-from-class="transform translate-y-0 opacity-100 scale-100"
            leave-to-class="transform translate-y-full opacity-0 scale-95"
            move-class="transition-all duration-300 ease-out"
        >
            <div
                v-for="(toast, index) in toasts"
                :key="toast.id"
                class="bg-primary rounded-lg flex items-stretch h-auto min-h-10"
                :style="{
                    boxShadow:
                        '0px 4px 8px 0px rgba(0, 0, 0, 0.3), 0px 12px 24px 0px rgba(0, 0, 0, 0.2)',
                    marginBottom: index === toasts.length - 1 ? '0' : '12px'
                }"
                role="alert"
            >
                <div class="flex items-center w-full h-full py-1 px-3">
                    <PhWarningDiamond
                        v-if="toast.type === 'error'"
                        :size="24"
                        weight="fill"
                        class="text-error-500 shrink-0"
                    />
                    <PhCheckCircle
                        v-else-if="toast.type === 'success'"
                        :size="24"
                        weight="fill"
                        class="text-success-500 shrink-0"
                    />
                    <div class="flex flex-col gap-1 p-3">
                        <p class="w-80 text-base text-white">{{ toast.message }}</p>
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>
